import { useCallback } from 'react'

export default function useStationSelector () {
  const optionsReducer = useCallback(data => {
    const trains = data?.stations?.reduce((stations, { crs_code, name }) => ([
      ...stations,
      {
        label: name,
        value: crs_code
      }
    ]), [])

    // sort in alphabetical order.
    const d = trains.sort(function(a, b) {
    const nameA = a.label.toUpperCase(); // ignore upper and lowercase
    const nameB = b.label.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    // names must be equal
    return 0;
  });
  
  return d

  }
  
  , [])
  

  return {
    optionsReducer
  }
}
